import { fork } from 'redux-saga/effects';
import appInitializerWatchers from './appInitializerSaga';
import currentUserWatchers from './currentUserSaga';
import farmWatchers from './farmSaga';
import featureWatchers from './featureSaga';
import harvestWatchers from './harvestSaga';
import legendWatchers from './legendSaga';
import mosaicWatchers from './mosaicSaga';
import userWatchers from './userSaga';
import weatherWatchers from './weatherSaga';
import operationsFieldsWatchers from './fieldsSaga';
import scoutingWatchers from './scoutingSaga';
import analyticsSagaWatchers from './analyticsSaga';
import trialRegionSaga from './trialRegionSaga';
import enrollmentSaga from './enrollmentSaga';
import multiOperationsFieldsWatcher from './fieldsMultiOperSaga';
import agVizWatchers from './agVizSaga';
import agVizInitWatchers from './agVizInitSaga';

export default function* root() {
  yield fork(appInitializerWatchers);
  yield fork(currentUserWatchers);
  yield fork(farmWatchers);
  yield fork(featureWatchers);
  yield fork(harvestWatchers);
  yield fork(legendWatchers);
  yield fork(mosaicWatchers);
  yield fork(userWatchers);
  yield fork(weatherWatchers);
  yield fork(operationsFieldsWatchers);
  yield fork(scoutingWatchers);
  yield fork(analyticsSagaWatchers);
  yield fork(trialRegionSaga);
  yield fork(enrollmentSaga);
  yield fork(multiOperationsFieldsWatcher);
  yield fork(agVizWatchers);
  yield fork(agVizInitWatchers);
}
